module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"es":{"title":"Si estás interesado en contratar nuestros servicios o tienes alguna consulta comercial","txt":"Resolvemos tus dudas sobre cualquier forma de pago con tarjeta."}}')
  delete Component.options._Ctor
}
